class MostActiveUsersDatatable {
    constructor(data, editMembers){
        console.log(data);
        this.datatable = this.init('#most-active-users-datatable', data, editMembers);
        this.data = data;
    }
    init(el, data, editMembers){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: false,
            searching: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[1, 'desc']],
            data: data,
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Member',
                    className: 'min-w-100px',
                    sortable: false,
                    render: function (data, type, row) {
                        let avatarUrl = '/media/goodaccess/avatars/svg/device.svg';
                        if (row['avatarID'] || row['isIdp']) {
                            avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['avatarID'] + '.svg';
                        }

                        if (row['password'] || row['isIdp']) {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden' + (row['isBlocked'] === 1 ? ' filter-grayscale' : '') + '">' +
                                '               <img src="' + avatarUrl + '" class="h-40px" alt="avatar">' +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                (row['connected'] ? '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>connected</div>"></span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div class="d-flex align-items-center">' + (editMembers ? '<div id="'+row['uuid']+'">' : '') + '<span class="fw-bold text-nowrap' + (editMembers ? ' text-decoration-underline-ga primary edit-member' : '') + ' text-primary mb-1 fs-6">' + row['name'] + '</span>' + (editMembers ? '</div>' : '') + (row['isOwner'] ? '<span class="badge badge-light-danger badge-sm ms-2 align-center">Owner</span>' : '') + (row['managerRole'] ? '<span class="badge badge-light-danger badge-sm ms-2 align-center">' + row['managerRole'] + '</span>' : '') + (row['meBadge'] ? '<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>' : '') + (row['portableDevice'] ? '<i class="fa-solid fa-mobile-screen-button ms-2 fs-4 align-middle" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Mobile Device"></i>' : '') + '</div>' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['vpnUserName'] + '</span>' +
                                '       </div>' +
                                '   </div>';
                        } else {
                            avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-unknown2.svg';
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px symbol-circle border ga-border-primary-300 me-3">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden' + (row['isBlocked'] === 1 ? ' filter-grayscale' : '') + '">' +
                                '               <img src="' + avatarUrl + '" class="h-40px" alt="avatar">' +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <span class="fw-bold text-primary mb-1 fs-6"><span>' + row['name'] + '</span></span>' +
                                '       </div>' +
                                '   </div>';
                        }

                    }
                },
                {
                    data: 'connectedTime',
                    title: 'Connected Time',
                    sortable: true,
                    render: function (data, type, row) {
                        if ( type === 'sort' || type === 'type' ) {
                            return row['connectedMinutes'];
                        }

                        let connectedMinutes = row['connectedMinutes'];
                        let hoursConnected = Math.floor(connectedMinutes / 60);
                        let minutesConnected = Math.round(connectedMinutes % 60);
                        let connectedTime;

                        if (hoursConnected > 0 && minutesConnected > 0) {
                            connectedTime = hoursConnected + 'h ' + minutesConnected + 'min';
                        } else if (hoursConnected > 0 && minutesConnected === 0) {
                            connectedTime = hoursConnected + 'h';
                        } else {
                            connectedTime = minutesConnected + 'min';
                        }
                        return connectedTime;
                    }
                },
                {
                    data: 'uploadedData',
                    title: 'Data',
                    sortable: true,
                    className: 'min-w-80px',
                    render: function (data, type, row) {
                        if ( type === 'sort' || type === 'type' ) {
                            return row['dataDownloadedMb'];
                        }

                        let downloadedMB = Math.round(row['dataDownloadedMb']);
                        let downloadedData;

                        if (downloadedMB < 1024) {
                            downloadedData = downloadedMB + 'MB';
                        } else {
                            downloadedData = (downloadedMB / 1024).toFixed(2) + 'GB';
                        }

                        let uploadedMB = Math.round(row['dataUploadedMb']);
                        let uploadedData;

                        if (uploadedMB < 1024) {
                            uploadedData = uploadedMB + 'MB';
                        } else {
                            uploadedData = (uploadedMB / 1024).toFixed(2) + 'GB';
                        }

                        return '<div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-up"></i>' +
                            '       <span>'+uploadedData+'</span>' +
                            '   </div>' +
                            '   <div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-down"></i>' +
                            '       <span>'+downloadedData+'</span>' +
                            '   </div>';
                    }
                },
            ]
        }).on('preDraw', function () {
            $('#most-active-users-datatable_wrapper').show();
            $('#most-active-users-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
        }).on('draw', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#most-active-users-datatable_wrapper').hide();
                $('#most-active-users-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#most-active-users-datatable_wrapper').show();
                $('#most-active-users-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '#most_active_users_table [data-kt-docs-table-filter=search]');
        $('#most_active_users_table select[name=most-active-users-datatable_length]').select2({
            minimumResultsForSearch: -1,
            dropdownParent: $('#most_active_users_table')
        });
        return datatable;
    }
}
window.MostActiveUsersDatatable = MostActiveUsersDatatable;